<script>
export default {
  name: 'GradeList',
  props: {
    grades: {
      type: Array,
      default: function() {
        return []
      },
    },
  },
}
</script>

<template>
  <section :title="$t('booking.gradesLabel')" class="mb-1">
    <v-chip
      v-for="(p, index) in grades"
      :key="'grade' + index + p.id"
      small
      color="light-blue lighten-5"
      class="mr-1 mt-1 blue--text"
    >
      {{ p.title }}
    </v-chip>
  </section>
</template>
